import React from 'react';
import Select from 'react-select';
import generateLocator from 'utils/generate-locator';

const FilterDropdown = <T, >({
  name, options, currentState, onChange,
}: {
  name: string
  options: { value: T, label: string }[],
  currentState?: T,
  onChange: (filterState: T) => void
}) => {
  const labelId = generateLocator(name, 'filter-label');
  return <div className='text-left m-2'>
    <label id={labelId}>{name}</label>
    <Select
      aria-labelledby={labelId}
      placeholder={name}
      className='w-40 mt-1'
      options={options}
      value={currentState ? options.filter(o => o.value === currentState) : null}
      onChange={event => {
        event && onChange(event.value as T);
      }} />
  </div>;
};

export default FilterDropdown;
